// Formats d'affichage partagés par l'API (libellés calculés) et le front.

const nf0 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const nf2 = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Entier groupé à la française : 13 220. */
export const int = (v: number): string => nf0.format(Math.round(v));

/** Montant compact : 850 €, 13 k€, 1,2 M€. Signe moins typographique. */
export function eur(v: number): string {
  const a = Math.abs(v);
  const s = v < 0 ? '−' : '';
  if (a >= 1e6) return `${s}${nf1.format(a / 1e6)} M€`;
  if (a >= 1e3) return `${s}${nf0.format(Math.round(a / 1e3))} k€`;
  return `${s}${nf0.format(Math.round(a))} €`;
}

/** Montant compact signé : +13 k€, −2 k€. */
export const eurSigned = (v: number): string => (v > 0 ? '+' : '') + eur(v);

/** Montant en millions, deux décimales : 14,94 M€. */
export const meur = (v: number): string => `${nf2.format(v)} M€`;

/** Montant en millions signé. */
export const meurSigned = (v: number): string => (v > 0 ? '+' : v < 0 ? '−' : '') + meur(Math.abs(v));

/** Pourcentage : 12,4 %. */
export const pct = (v: number, digits = 1): string =>
  `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v)} %`;

/** Écart en points : +1,2 pt. */
export const pts = (v: number): string => `${v > 0 ? '+' : v < 0 ? '−' : ''}${nf1.format(Math.abs(v))} pt`;

/** Date ISO (AAAA-MM-JJ) en jj/mm, avec l'année si elle diffère de l'année de référence. */
export function dateFr(iso: string | null | undefined, refYear?: number): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  if (!y || !m || !d) return '';
  return refYear !== undefined && Number(y) === refYear ? `${d}/${m}` : `${d}/${m}/${y.slice(2)}`;
}

/** Date ISO en jj/mm/aaaa. */
export function dateLong(iso: string | null | undefined): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

/** Nombre de jours entre deux dates ISO (b − a). */
export function daysBetween(a: string, b: string): number {
  return Math.round((Date.parse(b.slice(0, 10)) - Date.parse(a.slice(0, 10))) / 86_400_000);
}

/** Ajoute n jours à une date ISO. */
export function addDays(iso: string, n: number): string {
  const t = new Date(Date.parse(iso.slice(0, 10)) + n * 86_400_000);
  return t.toISOString().slice(0, 10);
}

/** Ajoute n mois à une date ISO (jour borné à la fin du mois). */
export function addMonths(iso: string, n: number): string {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number) as [number, number, number];
  const t = new Date(Date.UTC(y, m - 1 + n, 1));
  const last = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0)).getUTCDate();
  t.setUTCDate(Math.min(d, last));
  return t.toISOString().slice(0, 10);
}
